var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f283a5",
    d: "M5.42 54.75L5.42 60.75 17.12 48.96 14.33 46.88 5.42 54.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#72caaf",
    d: "M57.58 4.59L57.58 10.25 49.1 18.6 45.6 15 57.58 4.59z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#c2cde7",
    d: "M37.26,14.74h8a8,8,0,0,1,8,8v8a0,0,0,0,1,0,0h-24a0,0,0,0,1,0,0v-8a8,8,0,0,1,8-8Z",
    transform: "rotate(45 41.264 22.732)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#acb7d0",
    d: "M27.12,19.91l17,17,.46-.46a5,5,0,0,0,0-7.07l-9.9-9.9a5,5,0,0,0-7.07,0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3dded",
    d: "M21.49,27.51h24a4,4,0,0,1,4,4v1a1,1,0,0,1-1,1h-30a1,1,0,0,1-1-1v-1a4,4,0,0,1,4-4Z",
    transform: "rotate(45 33.483 30.509)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#c2cde7",
    d: "M17.74,34.26h8a8,8,0,0,1,8,8v8a0,0,0,0,1,0,0h-24a0,0,0,0,1,0,0v-8A8,8,0,0,1,17.74,34.26Z",
    transform: "rotate(-135 21.736 42.265)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3dded",
    d: "M17.51,31.49h24a4,4,0,0,1,4,4v1a1,1,0,0,1-1,1h-30a1,1,0,0,1-1-1v-1a4,4,0,0,1,4-4Z",
    transform: "rotate(-135 29.515 34.485)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#acb7d0",
    d: "M36,44.95l-17-17-.46.46a5,5,0,0,0,0,7.07l9.9,9.9a5,5,0,0,0,7.07,0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M17.14 34.84a1 1 0 1 0 1.41 1.41L20 34.84a1 1 0 0 0-1.41-1.41zM21.38 40.08a1 1 0 0 0 .71-.29l1.41-1.41A1 1 0 0 0 22.09 37l-1.41 1.41a1 1 0 0 0 .71 1.71zM24.92 43.62a1 1 0 0 0 .71-.29L27 41.91a1 1 0 0 0-1.41-1.41l-1.41 1.41a1 1 0 0 0 .71 1.71zM28.45 47.15a1 1 0 0 0 .71-.29l1.41-1.41A1 1 0 0 0 29.16 44l-1.41 1.41a1 1 0 0 0 .71 1.71zM33.84 18.14l-1.41 1.41A1 1 0 1 0 33.84 21l1.41-1.41a1 1 0 0 0-1.41-1.41zM37.37 21.68L36 23.09a1 1 0 1 0 1.41 1.41l1.41-1.41a1 1 0 0 0-1.41-1.41zM40.91 25.21L39.5 26.63A1 1 0 1 0 40.91 28l1.41-1.41a1 1 0 0 0-1.41-1.41zM44.45 28.75L43 30.16a1 1 0 1 0 1.41 1.41l1.41-1.41a1 1 0 0 0-1.41-1.41z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M55.87,9.54l-7.54,7.54-.71-.71-.71-.71L57.28,5.3a1,1,0,0,0-1.41-1.41L45.51,14.25l-.71-.71a9,9,0,0,0-12.73,0l-5,5a5,5,0,0,0-6.29.64l-.71.71a2,2,0,0,0-.45.69,2,2,0,0,0-.69.45l-.71.71A5,5,0,0,0,17.57,28l-5,5a9,9,0,0,0,0,12.73l.71.71L5.72,54a1,1,0,0,0,1.41,1.41l7.54-7.54.71.71.71.71L5.72,59.7a1,1,0,1,0,1.41,1.41L17.49,50.75l.71.71a9,9,0,0,0,12.73,0l5-5a5,5,0,0,0,6.29-.64l.71-.71a2,2,0,0,0,.45-.69,2,2,0,0,0,.69-.45l.71-.71A5,5,0,0,0,45.43,37l5-5a9,9,0,0,0,0-12.73l-.71-.71L57.28,11a1,1,0,0,0-1.41-1.41ZM29.51,50a7,7,0,0,1-9.9,0l-2.83-2.83-2.12-2.12h0L14,44.38a7,7,0,0,1,0-9.9l4.95-5L34.46,45.09Zm7.07-5.66-17-17a3,3,0,0,1,0-4.24l.43-.44h0L41.26,43.95h0l-.44.44A3.07,3.07,0,0,1,36.59,44.38Zm6.8-2.56-.43.44h0L21.74,21.05h0l.44-.44a3,3,0,0,1,4.24,0l17,17a3,3,0,0,1,0,4.24ZM49,20.62a7,7,0,0,1,0,9.9l-4.95,5L28.54,19.91l5-5a7,7,0,0,1,9.9,0l2.83,2.83,2.12,2.12h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnected);
export default __webpack_public_path__ + "static/media/connected.6b65d23bf2f555272be2c1d4bbfd2a86.svg";
export { ForwardRef as ReactComponent };